import React from "react";
import { Box, Divider, List, ListItem, Typography } from "@mui/material";
import { TextFeedbackDto } from "../../../types/workshopTypes";

interface WorkshopInstanceTextEvaluationProps {
  textFeedback: TextFeedbackDto[];
}

/**
 * This component is responsible for rendering the textual feedback for the workshop instance evaluation page.
 * @param  textFeedback the textual feedback for the workshop instance evaluation page
 * @returns the textual feedback for the workshop instance evaluation page
 */
const WorkshopInstanceTextEvaluation: React.FunctionComponent<WorkshopInstanceTextEvaluationProps> = ({
  textFeedback,
}: WorkshopInstanceTextEvaluationProps) => {
  return (
    <Box sx={{ mt: 3, pb: 3 }}>
      <Divider sx={{ mb: 2 }} />
      <Typography fontWeight={"bold"} fontSize={18}>
        Verbesserungskommentare:
      </Typography>
      {textFeedback.map((feedback, index) => {
        return (
          <Box
            key={`TextFeedback-${index}`}
            sx={{ mt: 3, border: 1, borderColor: "secondary.main", borderRadius: 1, p: 2 }}
          >
            <Typography fontWeight={"bold"}>{feedback.questionText}</Typography>
            <List dense sx={{ listStyle: "square", pl: 2 }}>
              {feedback.comments.length > 0 ? (
                feedback.comments.map((comment, index) => {
                  return (
                    <ListItem key={`Comment-${index}`} sx={{ display: "list-item" }} disablePadding disableGutters>
                      <Typography>{comment}</Typography>
                    </ListItem>
                  );
                })
              ) : (
                <ListItem key={`Comment-${index}`} sx={{ display: "list-item" }} disablePadding disableGutters>
                  <Typography>Diese Frage wurde von keinem Teilnehmer beantwortet.</Typography>
                </ListItem>
              )}
            </List>
          </Box>
        );
      })}
    </Box>
  );
};

export default WorkshopInstanceTextEvaluation;
